import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {createHead} from "@vueuse/head";
const head = createHead()
// import loadScriptPlugin from "@/plugins/loadScriptPlugin";


createApp(App).use(store).use(router).use(head).mount('#app')
